export default __webpack_public_path__ + "static/media/accepted-late.9564b4ce.svg";